import React, { FC } from 'react';
import { camelToSnake } from '../../../../caseUtils';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import {
  OpenCommentaryCard,
  PaperCommentaryCard,
  HybridCommentaryCard,
} from '../../../../commentary/card';
import { TypeLabel } from '../../../../commentary/commentary.types';
import { EntityCommentary } from '../../../search.types';
import { GetCommentaryResponse } from '../commentaries-modal/decisionApi';
import { HitCommentariesListSeeMore } from './HitCommentariesListSeeMore';

type Props = {
  commentaries: Array<EntityCommentary>;
  docId: string;
  numberOfComments: number;
  nextCommentAuthors: string[];
  otherCommentAuthorsCount: number;
  source: string;
  searchType: string;
  allCommentariesGetter: (
    docId: string,
    query: string,
  ) => Promise<{ data: Array<GetCommentaryResponse> }>;
};

export const HitCommentariesList: FC<Props> = ({
  commentaries,
  numberOfComments,
  otherCommentAuthorsCount,
  nextCommentAuthors = [],
  source,
  docId,
  allCommentariesGetter,
  searchType,
}) => {
  const onCommentaryClicked = (commentary: EntityCommentary) => () => {
    doctrineAnalytics('Search AbstractCommentClicked', {
      ...camelToSnake(commentary),
      reportOriginalQueryKey: true,
      search_type: searchType,
    });
  };

  const extraCommentaries = numberOfComments - commentaries.length;
  const hasMore = extraCommentaries > 0;
  const hasCommentaries = numberOfComments > 0;

  if (!hasCommentaries) {
    return null;
  }

  return (
    <div className="hit-commentaries-list">
      <div>
        {commentaries.map(commentary => {
          if (commentary.typeLabel === TypeLabel.HYBRID) {
            return (
              <HybridCommentaryCard
                className="search-commentary-item"
                commentary={commentary}
                key={commentary.commentaryId}
                source={source}
                onCommentaryClicked={onCommentaryClicked(commentary)}
                small
              />
            );
          }
          if (commentary.typeLabel === TypeLabel.PAPER) {
            return (
              <PaperCommentaryCard
                className="search-commentary-item"
                key={commentary.commentaryId}
                commentary={commentary}
                small
              />
            );
          }
          return (
            <OpenCommentaryCard
              className="search-commentary-item"
              key={commentary.commentaryId}
              commentary={commentary}
              source={source}
              onCommentaryClicked={onCommentaryClicked(commentary)}
              small
            />
          );
        })}
      </div>
      {hasMore && (
        <HitCommentariesListSeeMore
          docId={docId}
          allCommentariesGetter={allCommentariesGetter}
          searchType={searchType}
          numberOfComments={numberOfComments}
          commentaries={commentaries}
          nextCommentAuthors={nextCommentAuthors}
          otherCommentAuthorsCount={otherCommentAuthorsCount}
        />
      )}
    </div>
  );
};
